<template>
  <div>
    <header class="custom-shadow">
      <div class="container-fluid">
        <nav class="navbar navbar-expand-lg navbar-light bg-white p-0">
          <router-link class="navbar-brand" to="/">
            <img
              class="img-fluid"
              src="/assets/images/brand1.png"
              width="150px"
              id="brand-logo"
            />
          </router-link>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNavDropdown">
            <ul class="navbar-nav ml-auto text-center align-items-center">
              <li class="nav-item">
                <router-link class="nav-link" to="/">Home</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/about">About Us</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/marketplace"
                  >Marketplace</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/inventory"
                  >Inventory Manager</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/aggregator"
                  >Aggregator</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/blog">Blog</router-link>
              </li>

              <!-- <li class="nav-item">
                <a
                  class="nav-link cart"
                  href="javascript:void(0)"
                  @click="isCartClicked = !isCartClicked"
                >
                  <font-awesome-icon
                    :icon="['fas', 'shopping-cart']"
                    class=""
                  />
                  <span class="badge">
                    {{ cartCount | placeholder("10") }}
                  </span>
                </a>
                <div class="shopping-cart" :class="{ active: isCartClicked }">
                  <div
                    class="shopping-cart-header d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <small>
                        <font-awesome-icon
                          :icon="['fas', 'shopping-cart']"
                          class="cart-icon"
                        />
                        <span class="badge">
                          {{ cartCount | placeholder("0") }}
                        </span>
                      </small>
                    </div>
                    <div class="shopping-cart-total">
                      <span class="lighter-text text-muted">Total: </span>
                      <span class="big total h5 text-black">N461.15</span>
                    </div>
                  </div>

                  <ul class="shopping-cart-items text-left px-1 my-3">
                    <li class="clearfix">
                      <img
                        src="/assets/images/soybean.jpg"
                        class="img-fluid"
                        alt="item1"
                      />
                      <div class="">
                        <span class="item-name">SoyaBeans</span>
                        <span class="item-detail">x 30 tonne</span>
                        <span class="item-quantity">- Grade 1</span>
                        <span class="item-price">N12,249.50</span>
                      </div>
                    </li>

                    <li class="clearfix">
                      <img
                        src="/assets/images/soybean.jpg"
                        class="img-fluid"
                        alt="item1"
                      />
                      <div class="">
                        <span class="item-name">SoyaBeans</span>
                        <span class="item-detail">x 30 tonne</span>
                        <span class="item-quantity">- Grade 1</span>
                        <span class="item-price">N12,249.50</span>
                      </div>
                    </li>

                    <li class="clearfix">
                      <img
                        src="/assets/images/soybean.jpg"
                        class="img-fluid"
                        alt="item1"
                      />
                      <div class="">
                        <span class="item-name">SoyaBeans</span>
                        <span class="item-detail">x 30 tonne</span>
                        <span class="item-quantity">- Grade 1</span>
                        <span class="item-price">N12,249.50</span>
                      </div>
                    </li>
                  </ul>

                  <a href="#" class="btn btn-dark btn-block rounded-pill"
                    >Checkout <i class="fa fa-chevron-right"></i
                  ></a>
                </div>
              </li> -->
              <div class="login__box">
                <li class="nav-item">
                  <router-link class="nav-link" to="/login">Login</router-link>
                </li>
              </div>
              <div class="register__box">
                <li class="nav-item">
                  <router-link class="nav-link" id="white-text" to="/Signup"
                    >Create Account</router-link
                  >
                </li>
              </div>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      isCartClicked: false
    };
  }
};
</script>

<style lang="scss" scoped>
$primary-color: #95c720;
$second-color: #f8770c;
$light-text: #abb0be;

.custom-shadow {
  box-shadow: 0 13px 35px -12px rgba(35, 35, 35, 0.15);
}
.navbar-light .navbar-nav .nav-link {
  font-size: 14px;
  color: black !important;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  padding: 9px;
}
a.nav-link.router-link-exact-active.router-link-active {
  color: #95c720 !important;
}

nav {
  a.cart {
    display: inline;
    padding-left: 20px;
    color: #777777;
    text-decoration: none;

    &:hover {
      color: black;
    }
  }
}

/////////// --END DEMO CSS -- ///////////

.badge {
  background-color: red;
  border-radius: 10px;
  color: white;
  display: inline-block;
  font-size: 12px;
  line-height: 1;
  padding: 3px 7px;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
}

.shopping-cart {
  background: white;
  width: 320px;
  position: absolute;
  top: 70px;
  right: 0px;
  border-radius: 3px;
  padding: 20px;
  overflow: hidden;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26) !important;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  opacity: 0;
  -webkit-transform-origin: right top 0;
  -webkit-transform: scale(0);
  transform-origin: right top 0;
  transform: scale(0);
  z-index: 99;

  &.active {
    opacity: 1;
    -webkit-transform-origin: right top 0;
    -webkit-transform: scale(1);
    transform-origin: right top 0;
    transform: scale(1);
  }

  .shopping-cart-header {
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 15px;

    .shopping-cart-total {
      float: right;
    }
  }

  .shopping-cart-items {
    list-style: none;
    max-height: 360px;
    overflow-x: hidden;

    li {
      margin-bottom: 18px;
      display: flex;
    }

    img {
      margin-right: 12px;
      max-width: 70px;
      max-height: 70px;
    }

    .item-name {
      display: block;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 16px;
    }

    .item-detail,
    .item-quantity {
      font-size: 12px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      margin-right: 8px;
    }

    .item-price {
      display: block;
      color: $primary-color;
    }

    .item-quantity {
      color: $light-text;
    }
  }
}

.shopping-cart:before {
  bottom: 100%;
  left: 89%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-bottom-color: red;
  border-width: 8px;
  margin-left: -8px;
}

.cart-icon {
  color: #515783;
  font-size: 24px;
  margin-right: 7px;
  float: left;
}

.button {
  background: $second-color;
  color: white;
  text-align: center;
  padding: 12px;
  text-decoration: none;
  display: block;
  border-radius: 3px;
  font-size: 16px;
  margin: 25px 0 15px 0;
  text-transform: uppercase;
  &:hover {
    background: lighten($second-color, 3%);
  }
  i {
    padding-left: 5px;
  }
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

.login__box {
  border: 1px solid black;
  border-radius: 30px;
  margin: 5px;
}

.register__box {
  display: flex;
  align-items: center;
  background-color: black;
  border-radius: 30px;
}

@media (max-width: 576px) {
  .register__box {
    margin-bottom: 5px;
  }
}

#white-text {
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  padding: 10px;
  color: rgba(255, 255, 255, 0.859375) !important;
}
</style>
